import React, { useEffect, useReducer } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import { ErrorBoundary } from 'react-error-boundary'

import AssementContext from '../../../context/learningContentContext/assement-context';
import assementReducer from '../../../reducers/assement-reducer';
import { GetAssessmentsByLearningContentId } from '../../../actions/learningcontent-actions';

import AssementHolder from './AssementHolder'
import Loading from '../../shared/Loading'
import { DefaultLayout, BreadcrumbsCustom } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import ErrorFallback from '../../shared/ErrorFallback'

import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper';
import { getLearningContentFromSession } from '../../../utils/helpers/others/SessionHelper';
import { AssementData } from '../../../utils/services/cache/ClientCache'

const Assement = () => {
    const history = useHistory();
    const [assementContext, dispatch] = useReducer(assementReducer);
    const classes = useStyles();
    const [loading, setLoading] = React.useState(true);
    const learningContentSession = JSON.parse(getLearningContentFromSession());
    let assessmentTypeName = AssementData.getAssementTypeName();
    let assessmentRewardPoint = AssementData.getAssementRewardPoint();

    useEffect(() => {
        initAssementQuestionList();
    }, []);

    const initAssementQuestionList = async () => {
        let response = await GetAssessmentsByLearningContentId(learningContentSession.learningContentId);
        setLoading(false);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        loadAssessment(response);
    };

    const loadAssessment = (response) => {
        response.data.map(element => {
            element.assessmentType = element.assessmentType && element.assessmentType.trim()
            return element
        });

        let questionList = response.data;
        let _multipleChoiceContents = [];
        let _isSecretCode = false;

        if (assessmentTypeName === 'Multiple Choice' || assessmentTypeName === 'Multiple Choice and Secret Code') {
            questionList.filter(item => item.assessmentType !== 'Secret Code').map((AssementQuestion) => {
                let multipleChoiceContent = {
                    question: AssementQuestion,
                    answers: AssementQuestion.learningContentAssessmentOptionModels,
                    selectedAnswer: {},
                }
                _multipleChoiceContents.push(multipleChoiceContent);
            })
        }
        else if (assessmentTypeName === 'Multiple Answers' || assessmentTypeName === 'Multiple Answers and Secret Code') {
            let answers = []
            questionList.filter(item => item.assessmentType !== 'Secret Code').map((AssementQuestion) => {
                let limit = 0

                answers = AssementQuestion.learningContentAssessmentOptionModels
                answers.map(item => {
                    if (item.isCorrect) limit += 1
                    item.isChecked = false
                    item.hintOn = false;
                    return item
                })
                let multipleChoiceContent = {
                    question: AssementQuestion,
                    answers,
                    limit
                }

                _multipleChoiceContents.push(multipleChoiceContent);
            });
        }
        else if (assessmentTypeName === 'Secret Code') {
            _isSecretCode = true;
        }        
        dispatch({ type: 'SET_IS_SECRETCODE', isSecretCode: _isSecretCode });
        dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: _multipleChoiceContents });
        dispatch({ type: 'SET_INTERACTIVE_CONTENT_ID', interactiveContentId: learningContentSession.learningContentId });
        dispatch({ type: 'SET_TRAIT_GROUP_ID', traitGroupId: AssementData.getAssementTraitGroupId() });
        dispatch({ type: 'SET_ASSESSMENT_TYPE', assessmentType: AssementData.getAssementTypeId() });
        dispatch({ type: 'SET_ASSESSMENT_TYPE_NAME', assessmentTypeName: assessmentTypeName });
    }

    const breadcrumbsData = [
        {
            text: 'Learning Contents',
            href: '/LearningContentCategories'
        },
        {
            text: learningContentSession.learningContentCategoryName,
            href: learningContentSession.learningContentCategoryId === 0 ? '/NonTraitLearningContents' : '/LearningContents'
        },
        {
            text: AssementData.getAssementTitle(),
            href: '/LearningContent'
        },
        {
            text: 'Quiz',
            href: ''
        },
    ];

    if (loading) return <Loading />;

    return (
        <AssementContext.Provider value={{ assementContext, dispatch }}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <DefaultLayout
                    title='Assessment'
                    type='Learning Content'
                    description=''
                    image={getIconLearningContent().img_lc_bg_header}
                    coin={assessmentRewardPoint ? assessmentRewardPoint : '0'}
                >
                    <Grid container>
                        <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} />
                        <Grid item sm={12} md={6} classes={{ root: classes.rootGridContentContainer }}>
                            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                            <Typography classes={{ root: classes.rootNote }}>Please do the assessment to best of your knowledge</Typography>
                            <Grid container classes={{ root: classes.rootAssessmentHolder }}>
                                <AssementHolder />
                            </Grid>
                        </Grid>
                    </Grid>
                </DefaultLayout>
            </ErrorBoundary>
        </AssementContext.Provider>
    );
};

export default Assement;